import { useCallback, useEffect, useState, useRef } from "react";
import { Input, Form, Button, Select, Upload } from "antd";
import { useNavigate, useLocation } from "react-router-dom";

import { Warning2, DocumentUpload } from "iconsax-react";
import {
  ref as sRef,
  uploadBytes,
  getDownloadURL,
  getStorage,
} from "firebase/storage";
import { ref, child, get } from "firebase/database";
import Swal from "sweetalert2";

import PageHeader from "../../../components/PageHeader";

import { useProfiles } from "../../../hooks/profile";
import { useAuth } from "../../../hooks/auth";
import { database } from "../../../config/firebase";

import { Container, Main } from "./styles";
import Footer from "../../../components/Footer";

function geraStringAleatoria(tamanho: number) {
  let stringAleatoria = "";
  const caracteres =
    "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";
  for (let i = 0; i < tamanho; i += 1) {
    stringAleatoria += caracteres.charAt(
      Math.floor(Math.random() * caracteres.length)
    );
  }
  return stringAleatoria;
}

function ProfileFormEdit() {
  const { getAll, editProfiles, loadingProfiles } = useProfiles();
  const navigate = useNavigate();
  const { state } = useLocation();
  const uid = state.id;
  const formRef = useRef(null);

  const { user } = useAuth();

  useEffect(() => {
    async function loadData() {
      if (!user?.uid) return;
      try {
        await getAll(user.uid);
      } catch (error) {
        navigate("/");
      }
    }
    loadData();
  }, [getAll, navigate, user?.uid]);

  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [avatar, setAvatar] = useState("");
  const [telefone, setTelefone] = useState("");
  const [subject, setSubject] = useState("Selecione uma opção");

  const getProfile = useCallback(() => {
    Swal.fire({
      title: "Carregando...",
      showConfirmButton: false,
      allowEscapeKey: false,
      allowOutsideClick: false,
      didOpen: () => {
        const runGet = async () => {
          Swal.showLoading();
          try {
            const snapshot = await get(child(ref(database), `users/${uid}`));
            if (snapshot.exists()) {
              const data = snapshot.val();
              setName(data.name);
              setEmail(data.email);
              setAvatar(data.avatar);
              setTelefone(data.telefone);
              setSubject(data.institution);

              if (formRef.current) {
                (formRef.current as any).setFieldsValue({
                  name: data.name,
                  email: data.email,
                  institution: data.institution,
                  avatar: data.avatar,
                  telefone: data.telefone,
                });
              }
            } else {
              Swal.fire({
                title: "Nenhum dado disponível",
                icon: "warning",
                showConfirmButton: true,
                allowEscapeKey: false,
              });
            }
            Swal.close();
          } catch (error) {
            console.error("Failed to fetch profile:", error);
            Swal.close();
          }
        };
        runGet();
      },
    });
  }, [uid]);

  useEffect(() => {
    getProfile();
  }, [getProfile]);

  const customUpload = async ({ file }: any) => {
    const storage = getStorage();
    const metadata = {
      contentType: "image/jpeg",
    };

    const nick = geraStringAleatoria(16);
    const imageName = user?.uid;
    const imgFile = sRef(storage, `avatar/${imageName + nick}.png`);
    Swal.fire({
      title: "Anexando imagem...",
      showConfirmButton: false,
      allowEscapeKey: false,
      allowOutsideClick: false,
      didOpen: () => {
        const runUpload = async () => {
          Swal.showLoading();
          try {
            await uploadBytes(imgFile, file, metadata);
            const downloadUrl = await getDownloadURL(imgFile);
            setAvatar(downloadUrl);
            Swal.close();
            Swal.fire({
              icon: "success",
              showConfirmButton: false,
              timer: 1000,
            });
          } catch (e) {
            Swal.fire({
              icon: "error",
              title: "Oops...",
              text: "Aconteceu algum erro inesperado.\nTente novamente.",
            });
            console.error("Upload failed:", e);
          }
        };
        runUpload();
      },
    });
  };
  interface FormProps {
    uid: string;
    name: string;
    email: string;
    password: string;
    telefone: string;
    institution: string;
  }

  const handleAddProfile = useCallback(
    async ({ name, email, password, telefone, institution }: FormProps) => {
      try {
        await editProfiles({
          uid,
          name,
          email,
          password,
          telefone,
          institution,
          avatar,
        });
      } catch (err) {
        console.log(err);
      }
    },
    [editProfiles, uid, avatar]
  );
  return (
    <Container id="page-profile-form">
      <PageHeader
        title="Editar Profissional"
        description="Preencha o formulário abaixo atualizar as informações do profissional"
        type="private"
      />
      <Main>
        <Form ref={formRef} onFinish={handleAddProfile}>
          <fieldset>
            <legend>Dados do Profissonal</legend>

            <Form.Item label="Nome Completo" name="name">
              <Input id="name" name="name" value={name} />
            </Form.Item>

            <Form.Item
              label="Email"
              name="email"
              rules={[{ required: true, message: "Email é obrigatório!" }]}
            >
              <Input
                id="email"
                name="email"
                type="email"
                placeholder="Insira o email do Profissonal"
                value={email}
              />
            </Form.Item>
            <Form.Item label="Foto para Identificação" name="avatar">
              <span> Formatos aceitos: (.png, .jpg, .jpeg)</span>
              <br />
              <br />
              <Upload
                id="avatar"
                accept=".png, .jpg, .jpeg"
                name="avatar"
                maxCount={1}
                customRequest={customUpload}
                style={{ width: "100%" }}
                listType="picture"
              >
                <Button
                  htmlType="button"
                  style={{
                    width: "100%",
                    textAlign: "start",
                    height: "5.6rem",
                    borderRadius: "0.8rem",
                  }}
                  icon={<DocumentUpload size={18} />}
                >
                  Enviar imagem
                </Button>
              </Upload>
            </Form.Item>
            <br />
            <Form.Item label="Instituição que faz parte" name="institution">
              <Select
                id="institution"
                style={{ marginBottom: "1.6rem" }}
                placeholder="Selecione uma Opção"
                value={subject !== "" ? subject : undefined}
                onChange={(value) => {
                  setSubject(value);
                }}
                options={[
                  {
                    value: "1",
                    label: "Escola Cosme E Damião",
                  },
                ]}
              />
            </Form.Item>
            <Form.Item
              label="Telefone para Contato"
              name="telefone"
              rules={[{ required: true, message: "Telefone é obrigatório!" }]}
            >
              <Input
                id="telefone"
                name="telefone"
                placeholder="Digite um número para contato"
                value={telefone}
              />
            </Form.Item>
          </fieldset>

          <footer>
            <p>
              <Warning2 size={48} />
              Atenção! <br />É necessário preecher todos os dados.
            </p>
            <Button htmlType="submit" disabled={loadingProfiles}>
              Salvar cadastro
            </Button>
          </footer>
        </Form>
      </Main>
      <Footer />
    </Container>
  );
}

export default ProfileFormEdit;
